import { IDetailItem } from "../../../shared/components/detail-item/detail-item.interface";
import { IEntityTS } from "../../../shared/interfaces/entity-ts.interface";
import { IFilter } from "../../../shared/interfaces/filter.interface";
import { IClient } from "../../clients-page/clients/clients.interface";
import { ITask } from "../../tasks-page/tasks/task.interface";


export interface IBillingDocumentFilter extends IFilter {
  filters: {
    task?: string;
    isDeleted?: boolean;
    client?: string;
    dateStart?: string;
    dateEnd?: string;
    dueDateStart?: string;
    dueDateEnd?: string;
    docNumber?: string;
    totalMin?: number;
    totalMax?: number;
    status?: string;
    number?: string;
    project?: string;
  },
  task?: string;
  project?: string;
}

export interface IBillingDocumentDetail {
  task?: ITask | string;
  detail?: string;
  tax?: number;
  taxPercentage?: number;
  subtotal?: number;
  price?: number; // deprecated
  total?: number;
}

export interface IBillingDocument extends IEntityTS {
  _id?: string;
  client?: IClient | string;
  date?: Date | string;
  dueDate?: Date | string;
  type?: IBillingDocumentNames;
  status?: string;
  number?: number;
  subtotal?: number;
  tax?: number;
  taxPercentage?: number;
  total?: number;
  details?: IDetailItem[];
  paymentMethodType?: string;
  paymentMethod?: string;
  docNumber?: string;
  termsAndConditions?: string;
  notes?: string;
  serie?: string;
  serieAndNumber?: string;
  receipt?: string | any;
  project?: string;

  // refactor: correctiveInvoice deberia tener interfaz propia
  billingDocument?: string;
}

export const IBillingDocumentTypes = {
  INVOICE: 'INVOICE'
}

export const IBillingDocumentTypeNames = {
  INVOICE: 'Factura'
}

export const PaymentMethodTypes = {
  TRANSFER: 'Transferencia bancaria',
  CASH: 'Efectivo',
  CUSTOMIZE: 'Otro',
}

export type IBillingDocumentNames = keyof typeof IBillingDocumentTypes;